(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    stateConfig.$inject = ['$stateProvider','APP'];
    function stateConfig($stateProvider,APP) {
    	$stateProvider
    	.state('birthCertificate', {
            parent: 'profileForm',
            url: '/investigationForm/:investigationFormId/birthCertificate',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	investigationFormId:null
            },
            views: {
                'dynamicViewForInvestigationForm': {
                    templateUrl: 'app/investigation/prospects/profile/investigation-form/birth-certificate/birth.certificate.html',
                    controller: 'BirthCertificateController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('investigationQuestion.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('investigationQuestion.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }],
                sectionIndex:['investigationFormIndexService','$timeout', function (investigationFormIndexService,$timeout) {
                	investigationFormIndexService.setInvestigationValue("bithcerticateForm");
                	/*$timeout(function() {
                	    angular.element('#profile').triggerHandler('click');
                	 });*/
                }]
            }
        });
    }
})();